module.exports = __webpack_public_path__ + "img/guillermopereira.2b9bdeca.jpg";